import { render } from "./play-icon.svg?vue&type=template&id=793f6a61"
import script from "./play-icon.svg?vue&type=script&lang=js"
export * from "./play-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2248/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__